var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.updateAvailable)?_c('div',{staticClass:"update-banner"},[_vm._v(" A apărut o versiune nouă a meniului. "),_c('button',{on:{"click":_vm.reload}},[_vm._v("Actualizează")])]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }